import {ColorConfigsT} from '@/lib/types/colors.types';

import {blackConfig} from './black.config';
import {blueConfig} from './blue.config';
import {cyanConfig} from './cyan.config';
import {dangerConfig} from './danger.config';
import {darkConfig} from './dark.config';
import {facebookConfig} from './facebook.config';
import {githubConfig} from './github.config';
import {googleConfig} from './google.config';
import {greenConfig} from './green.config';
import {indigoConfig} from './indigo.config';
import {infoConfig} from './info.config';
import {instagramConfig} from './instagram.config';
import {lightConfig} from './light.config';
import {mutedConfig} from './muted.config';
import {orangeConfig} from './orange.config';
import {pinkConfig} from './pink.config';
import {primaryConfig} from './primary.config';
import {purpleConfig} from './purple.config';
import {redConfig} from './red.config';
import {secondaryConfig} from './secondary.config';
import {successConfig} from './success.config';
import {tealConfig} from './teal.config';
import {twitterConfig} from './twitter.config';
import {warningConfig} from './warning.config';
import {whiteConfig} from './white.config';
import {yellowConfig} from './yellow.config';
import {youtubeConfig} from './youtube.config';

// Import other color configs as needed
// import {secondaryConfig} from './secondary.config';
// etc...

export const COLOR_CONFIGS: ColorConfigsT = {
  primary: primaryConfig,
  secondary: secondaryConfig,
  success: successConfig,
  warning: warningConfig,
  danger: dangerConfig,
  info: infoConfig,
  light: lightConfig,
  dark: darkConfig,
  white: whiteConfig,
  black: blackConfig,
  muted: mutedConfig,
  orange: orangeConfig,
  pink: pinkConfig,
  teal: tealConfig,
  purple: purpleConfig,
  red: redConfig,
  blue: blueConfig,
  green: greenConfig,
  cyan: cyanConfig,
  indigo: indigoConfig,
  yellow: yellowConfig,
  facebook: facebookConfig,
  google: googleConfig,
  twitter: twitterConfig,
  github: githubConfig,
  youtube: youtubeConfig,
  instagram: instagramConfig,
} as const;
